'use strict';

const { ACTIVE_CLASS, DISPLAY_CLASS } = require('../constants');
import { queryFirst, queryAll, removeClass, addClass, hasClass } from '../domUtil';

const formValidation = require('base/components/formValidation');
const { clearForm } = require('../clientSideValidation').functions;
const { guestEmptyWishlistTemplate } = require('../templates');
const $body = $('body');

const giftCardContainerSelector = '.gift-card-main ';
const selectedClass = 'selected';
let isCustomerClickedToTheInput;

/**
 * Function that sets hidden input value
 * @param { string } value - Gift card amount
 * @param { HTMLElement } giftCardContainer - Gift card container element
 */
function updateHiddenAmountField(value, giftCardContainer) {
    const amountHiddenInput = queryFirst('.gift-card-amount', giftCardContainer);

    if (amountHiddenInput) {
        amountHiddenInput.value = value;
    }
}

/**
 * Displays error message in case of invalid swatch state
 * @param { HTMLElement } giftCardContainer - Gift card container Element
 */
function displaySwatchErrorMessage(giftCardContainer) {
    const amountHiddenInput = queryFirst('.gift-card-amount', giftCardContainer);
    const attributesEl = queryFirst('.attributes', giftCardContainer);

    if (amountHiddenInput && attributesEl) {
        addClass(amountHiddenInput, 'is-invalid');
        amountHiddenInput.nextElementSibling.innerText = attributesEl.dataset.invalidSwatchError;
    }
}

/**
 * Checks if a selected swatch is not selectable/unavailable one
 * @param { HTMLElement } giftCardContainer - Gift card container Element
 * @returns { boolean } - a flag that states if currently selected swatch is valid or not
 */
function isInvalidSwatchSelected(giftCardContainer) {
    const selectedColorAttributeEl = queryFirst('.color-attribute .color-value.selected', giftCardContainer);

    if (selectedColorAttributeEl && hasClass(selectedColorAttributeEl, 'unselectable')) {
        return true;
    }
    return false;
}

/**
 * Clears giftcard error message
 * @param { HTMLElement } giftCardContainer - Gift card container element
 */
function clearAmountErrorMessage(giftCardContainer) {
    const amountHiddenInput = queryFirst('.gift-card-amount', giftCardContainer);
    const invalidFeedback = queryFirst('.gift-card-add-to-cart', giftCardContainer).nextElementSibling;

    removeClass(invalidFeedback, DISPLAY_CLASS);

    if (hasClass(amountHiddenInput, 'is-invalid')) {
        removeClass(amountHiddenInput, 'is-invalid');
    }
}

/**
 * Method is taken from OOTB
 * Function that runs after adding GC to cart
 * @param { Object } response - Response Object
 */
function postAddToCart(response) {
    $('.minicart').trigger('count:update', response);
    if (!response.error) {
        return;
    }
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    if ($('.add-to-cart-messages').length === 0) {
        $('body').append('<div class="add-to-cart-messages"></div>');
    }

    $('.add-to-cart-messages').append('<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">' + response.message + '</div>');

    setTimeout(function () {
        $('.add-to-basket-alert').remove();
    }, 5000);
}

/**
 * Event handler that runs on denomination change
 * @param { jQuery.event } event - event Object
 */
function amountSelectionHandler(event) {
    event.preventDefault();

    // set to false if the value was selected from amount list
    isCustomerClickedToTheInput = false;

    const { target } = event;
    const { attrValue } = target.dataset;

    const giftCardContainer = target.closest(giftCardContainerSelector);

    queryAll('.pill', giftCardContainer).forEach(item => {
        if (attrValue === item.dataset.attrValue) {
            addClass(item, selectedClass);
        } else {
            removeClass(item, selectedClass);
        }
    });

    const customAmountInput = queryFirst('.custom-amount .js-gift-card-purchase-amount', giftCardContainer);
    const customAmountAccordion = queryFirst('.js-custom-amount', giftCardContainer);
    if (customAmountInput && attrValue && parseInt(attrValue, 10)) {
        removeClass(customAmountAccordion, ACTIVE_CLASS);
        customAmountInput.setAttribute('disabled', true);

        clearAmountErrorMessage(giftCardContainer);
        updateHiddenAmountField(attrValue, giftCardContainer);
    }

    const wishlistProductCard = target.closest('.wishlist-card-item');
    if (wishlistProductCard) {
        const addToToteButton = queryFirst('.btn.gift-card-add-to-cart', wishlistProductCard);
        removeClass(addToToteButton, 'disabled');
    }
}

/**
 * Event handler that runs on denomination change on the cart page
 * @param { jQuery.event } event - event Object
 */
function amountSelectionHandlerCart(event) {
    event.preventDefault();
    const { target } = event;
    const { attrValue, displayValue } = target.dataset;

    const giftCardContainer = target.closest('.cart-gift-card');
    const selectedGiftCardAmountLabel = queryFirst('.quick-gift-card-menu-toggle span', giftCardContainer);
    if (!giftCardContainer || !selectedGiftCardAmountLabel) return false;

    queryAll('.quick-gift-card-menu-option', giftCardContainer).forEach(item => {
        if (attrValue === item.dataset.attrValue) {
            addClass(item, selectedClass);
            item.setAttribute('aria-selected', 'true');
            selectedGiftCardAmountLabel.textContent = displayValue;
            updateHiddenAmountField(attrValue, giftCardContainer);
        } else {
            removeClass(item, selectedClass);
            item.setAttribute('aria-selected', 'false');
        }
    });
}

/**
 * Event handler that runs on disabled custom input element
 * @param { jQuery.event } event - event Object
 */
function amountInputEnableHandler(event) {
    const inputOverlay = event.target;
    const giftCardContainer = inputOverlay.closest(giftCardContainerSelector);
    const inputAccordion = queryFirst('.js-custom-amount', giftCardContainer);
    const customAmountInput = queryFirst('.custom-amount .js-gift-card-purchase-amount', giftCardContainer);

    if (customAmountInput.hasAttribute('disabled')) {
        customAmountInput.removeAttribute('disabled');
    }

    if (hasClass(inputAccordion, ACTIVE_CLASS)) {
        customAmountInput.focus();
    }

    removeClass(customAmountInput, 'is-invalid');
}

/**
 * Event handler that runs on custom input element value changes
 * @param { jQuery.event } event - event Object
 */
function amountInputHandler(event) {
    const { target } = event;
    const giftCardContainer = target.closest(giftCardContainerSelector);

    const items = queryAll('.pill', giftCardContainer);
    removeClass(items, selectedClass);

    const { value } = target;
    if (value && parseInt(value, 10)) {
        items.forEach(item => item.setAttribute('disabled', true));
    } else {
        items.forEach(item => item.removeAttribute('disabled'));
    }

    clearAmountErrorMessage(giftCardContainer);
    updateHiddenAmountField(value, giftCardContainer);
    const wishlistProductCard = target.closest('.wishlist-card-item');
    if (wishlistProductCard) {
        const addToToteButton = queryFirst('.btn.gift-card-add-to-cart', wishlistProductCard);
        const disabledClass = 'disabled';
        value ? removeClass(addToToteButton, disabledClass) : addClass(addToToteButton, disabledClass);
    }
}

/**
 * Remove invalid class from amount input and add active class
 * @param { jQuery.event } event - event Object
 */
function amountInputActivated(event) {
    const { target } = event;
    const giftCardContainer = target.closest(giftCardContainerSelector);
    const amountInput = queryFirst('.js-gift-card-amount', giftCardContainer);
    const invalidFeedback = queryFirst('.gift-card-add-to-cart', giftCardContainer).nextElementSibling;

    removeClass(amountInput, 'is-invalid');
    addClass(amountInput, 'gift-card-amount-activated');
    removeClass(invalidFeedback, DISPLAY_CLASS);
}

/**
 * return error without call to backend if the input was clicked by customer
 * and customer clicks 'Add to Tote' without adding any value to the input field
 * @param { Object } formEl - form element
 * @returns {boolean} true or false
 */
function showEmptyFieldError(formEl) {
    const inputField = formEl.find('.js-pgc-amount');
    const inputName = inputField && inputField.attr('name');
    const inputErrMsg = inputField && inputField.attr('data-empty-value-msg');
    if (inputName && inputErrMsg) {
        formValidation(formEl, { fields: { [inputName]: inputErrMsg } });
        return true;
    }
    return false;
}

/**
 * @param { HTMLFormElement } formEl - form element
 * @returns {boolean} true or false, true means error should be displayed
 */
function showDecimalFieldError(formEl) {
    const amountHiddenInput = queryFirst('.js-pgc-amount', formEl);
    const amountVisibleInput = queryFirst('.js-gift-card-purchase-amount ', formEl);
    const customAmountAccordion = queryFirst('.js-custom-amount', formEl);

    if (!amountHiddenInput || !amountVisibleInput) {
        return false;
    }

    const value = parseFloat(amountHiddenInput.value);
    if (value % 1 === 0) {
        return false;
    }

    if (!value) {
        const invalidFeedback = queryFirst('.gift-card-add-to-cart', formEl).nextElementSibling;
        addClass(invalidFeedback, DISPLAY_CLASS);
    } else {
        addClass(amountHiddenInput, 'is-invalid');
    }

    // Open the accordion if the very first action was to press the Add to Tote button
    if (customAmountAccordion && !queryFirst('.pill.selected', formEl)) {
        addClass(customAmountAccordion, 'active');
    }

    amountHiddenInput.nextElementSibling.innerText = amountVisibleInput.dataset.badInputError;
    return true;
}

/**
 * Handles Gift card add to cart functionality
 * @param { jQuery.event } event - Event Object
 */
function addToCart(event) {
    event.preventDefault();
    const { target } = event;
    const formEl = $(target);

    // return error without call
    if (isCustomerClickedToTheInput && showEmptyFieldError(formEl)) return;
    if (showDecimalFieldError(target)) return;

    const targetCloseToCartPage = target.closest('.cart-page');
    const isQuickGiftCardAddToCart = queryFirst('.cart-gift-card');

    if (targetCloseToCartPage && !isQuickGiftCardAddToCart) {
        return;
    }

    // Display an error message when an unselectable swatch is selected on page load
    const pGiftCardContainer = target.closest('.p-gift-card-main');
    if (pGiftCardContainer && isInvalidSwatchSelected(pGiftCardContainer)) {
        displaySwatchErrorMessage(pGiftCardContainer);
        return;
    }

    const { actionUrl } = target.dataset;

    if (actionUrl) {
        const spinner = $.spinner();
        spinner.start();
        $.ajax({
            url: actionUrl,
            method: 'POST',
            data: formEl.serialize(),
            success: function (response) {
                spinner.stop();
                if (response.success) {
                    const wishlistCardItem = target.closest('.wishlist-card-item');
                    if (wishlistCardItem) {
                        const wishlistId = queryFirst('.wishlist-id', target).value;
                        const { removedWishListItem, wishListCountMessage, updatedWishListCount, itemsMsg, shopNewAsset } = response;
                        const selectedListDiv = queryFirst('.wishlists-lists-' + wishlistId);
                        const detailsTabItemCount = queryFirst('.header-items-count');
                        const listItemCount = queryFirst('.list-items-count', selectedListDiv);
                        if (removedWishListItem & (updatedWishListCount > 0)) {
                            wishlistCardItem.remove();
                            detailsTabItemCount.textContent = updatedWishListCount + ' items';
                            listItemCount.textContent = updatedWishListCount + ' items';
                        } else if (removedWishListItem) {
                            const emptyWishlistMarkup = guestEmptyWishlistTemplate(wishListCountMessage, shopNewAsset);
                            const wishlistCardItems = queryFirst('.wishlistItemCards');
                            if (wishlistCardItems) {
                                detailsTabItemCount.textContent = updatedWishListCount + ' ' + itemsMsg;
                                listItemCount.textContent = updatedWishListCount + ' ' + itemsMsg;
                                wishlistCardItems.outerHTML = emptyWishlistMarkup;
                            }
                        }
                    }
                    postAddToCart(response);
                    formEl.find('.form-control.is-invalid').removeClass('is-invalid');
                    $body.trigger('product:afterAddToCart', response);
                    $body.trigger('cart:triggerUpdate', response.cart);
                } else {
                    formValidation(formEl, response);
                }
            },
            error: function () {
                spinner.stop();
            }
        });
    }
}

/**
 * Function that sets PID on swatch selection
 * @param { jQuery.event } _event - Event object
 * @param { Object } response - Response object
 */
function setPid(_event, response) {
    const giftCardContainer = response.container[0];
    if (!hasClass(giftCardContainer, 'gift-card-main')) {
        return;
    }

    // Update hidden fields on swatch changes
    const giftCardProductIdInputs = queryAll('.gift-card-pid', giftCardContainer);
    if (giftCardProductIdInputs.length) {
        const { id } = response.data.product;

        giftCardProductIdInputs.forEach(giftCardProductIdInput => (giftCardProductIdInput.value = id));
        giftCardContainer.dataset.wishlistId = id;
    }

    // Clear Form errors on swatch changes
    if (hasClass(giftCardContainer, 'p-gift-card-main')) {
        const pGiftCardForm = queryFirst('form', giftCardContainer);
        if (pGiftCardForm) {
            clearForm(pGiftCardForm);
        }
    }
}

export default {
    initializeEvents: function () {
        const customAmountInput = queryFirst(`${giftCardContainerSelector} .custom-amount .js-gift-card-purchase-amount`);
        const pGiftCardForm = queryFirst(giftCardContainerSelector + '.gift-card');
        // Default Amount selection event
        $body.on('click', giftCardContainerSelector + '.amount-selector .pill', amountSelectionHandler);

        // Custom amount input field enabling event
        $body.on('click', giftCardContainerSelector + '.input-hidden-overlay', amountInputEnableHandler);

        // Custom amount input field enabling event
        $body.on('click', giftCardContainerSelector + '.js-custom-amount', amountInputEnableHandler);

        // Custom amount field value changes event
        $body.on('keyup', giftCardContainerSelector + '.custom-amount .form-control', amountInputHandler);

        // Gift card form submit event
        $body.off('submit.gcSubmit').on('submit.gcSubmit', pGiftCardForm, addToCart);

        // Show error under CTA if entered symbols in the field and Add To Tote clicked
        customAmountInput?.addEventListener('invalid', () => showDecimalFieldError(pGiftCardForm));

        // Gift card swatch selection - Product ID updation event
        $body.on('product:afterAttributeSelect', setPid);

        // Quick add gift card on cart page amount selection event
        $body.on('click', '.quick-gift-card-menu-dropdown .quick-gift-card-menu-option', amountSelectionHandlerCart);

        // add boolean value to the isCustomerClickedToTheInput if it it QuickView of the Phisical Gift Card
        // and customer did not add any value to the input field .js-pgc-purchase-amount
        $body.on('blur', '.js-pgc-quickview-form .js-pgc-purchase-amount', function (e) {
            isCustomerClickedToTheInput = !$(e.target).val();
        });

        // Remove invalid class from amount input and add active class
        customAmountInput?.addEventListener('click', amountInputActivated);
    }
};
